import { cva } from '@/styled-system/css';

export const menuItemRecipe = cva({
  base: {
    'position': 'relative',
    'display': 'block',
    'paddingBlock': 'tight',
    'paddingInline': 'default',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'background-color, color',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',
    'width': '100%',
    'cursor': 'pointer',

    'backgroundColor': {
      base: 'bg.elevated.mediumShadow',

      _notDisabled: {
        _hover: 'bg.action.neutral.alt.hover',
        _active: 'bg.action.neutral.alt.pressed',
      },
    },

    '_notDisabled': {
      _hover: {
        '&:where(a) > .c11n_menu__item-label': {
          textDecoration: 'underline',
        },
      },
    },

    '_focusVisible': {
      '& > .c11n_menu__item-label': {
        boxShadow: 'focus',
      },
    },
    '_hover': {
      '& > .c11n_menu__item-label': {
        boxShadow: 'none',
      },
    },

    '&:has(.c11n_menu__item-icon)': {
      display: 'grid',
      gridTemplate: `
        "icon label" auto
        "icon meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'tighter',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
  },
});
